import { useEffect } from 'react'

export const useScrollHandler = (callback: (e: Event) => void) => {
  useEffect(() => {
    document.addEventListener('scroll', callback)
    return () => {
      document.removeEventListener('scroll', callback)
    }
  }, [callback])
}
